import { CASE_PROVIDERS_TAG, CHRONOLOGY_TAG, CHRONOLOGY_UNDO_REDO_HISTORY_TAG } from '../constants';
import { api } from '../core';

export type RedoChronologyResponse = null;

interface RedoChronologyProps {
  caseId: string;
}

const redoChronologyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postRedoChronology: builder.query<RedoChronologyResponse, RedoChronologyProps>({
      query: ({ caseId }: RedoChronologyProps) => ({
        url: `redo/chronology`,
        method: 'POST',
        body: {
          caseId: caseId,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([CASE_PROVIDERS_TAG, CHRONOLOGY_TAG, CHRONOLOGY_UNDO_REDO_HISTORY_TAG]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postRedoChronology in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostRedoChronologyQuery } = redoChronologyApi;
